import { companyConstants } from '../constants/companyConstants';

const localCompany = JSON.parse(sessionStorage.getItem('company'));

let initialState = {};
if (localCompany) {
  initialState = { company: localCompany };
} else {
  initialState = {
    company: {},
  };
}

export default function company(state = initialState, action) {
  switch (action.type) {
    case companyConstants.GET_COMPANY_REQUEST:
      return {
        requesting: true,
      };
    case companyConstants.GET_COMPANY_SUCCESS:
      return {
        company: action.company,
      };
    case companyConstants.GET_COMPANY_FAILURE:
      return {};
    case companyConstants.CREATE_COMPANY_REQUEST:
      return {
        ...state,
        created: false,
        requestingCreate: true,
      };
    case companyConstants.CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        requestingCreate: false,
        created: true,
      };
    case companyConstants.CREATE_COMPANY_FAILURE:
      return {
        requestingUpdate: false,
        created: false,
        ...state,
      };
    case companyConstants.UPDATE_COMPANY_REQUEST:
      return {
        ...state,
        updated: false,
        requestingUpdate: true,
      };
    case companyConstants.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        requestingUpdate: false,
        updated: true,
      };
    case companyConstants.UPDATE_COMPANY_FAILURE:
      return {
        ...state,
        requestingUpdate: false,
        updated: false,
      };
    case companyConstants.SET_COMPANY:
      return {
        company: action.company,
      };
    case companyConstants.UNSET_COMPANY:
      return {};
    default:
      return state;
  }
}
